<div>
    <h3>Region {{ studentRegion.CODE }} - {{ studentRegion.NAME }}</h3>
</div>

<div class="table-responsive" *ngIf="dataSource.data.length > 0">
    <mat-table [dataSource]="dataSource">
        <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
            <mat-header-cell *matHeaderCellDef class="col">
                <h4>{{ col.label }}</h4>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div [ngSwitch]="col.key">
                    <div *ngSwitchCase="'schoolYear'" class="col">
                        <div>{{ element.inaSchoolEnrollment?.SchoolYear }}</div>
                    </div>
                    <div *ngSwitchCase="'district'" class="col">
                        <div>{{ element.inaSchoolEnrollment?.DistrictName }}</div>
                    </div>
                    <div *ngSwitchCase="'school'" class="col">
                        {{ element.inaSchoolEnrollment?.SchoolName }}
                    </div>
                    <div *ngSwitchCase="'type'" class="col">
                        {{ element.inaSchoolEnrollment?.EnrollmentType }}
                    </div>
                    <div *ngSwitchCase="'grade'" class="col">
                        {{ element.inaSchoolEnrollment?.Grade }}
                    </div>

                    <div *ngSwitchCase="'inaStatus'" class="col">
                        {{ element.inaSchoolEnrollment?.StatusTypeId == 1 ? 'Started' : 'Completed' }}
                    </div>
                    <div *ngSwitchCase="'inaVersion'" class="col">
                        {{ element.inaSchoolEnrollment?.TermDurationId == 1 ? 'Initial' : 'Annual' }}
                    </div>
                    <div *ngSwitchCase="'createdDate'" class="col">
                        <div class="row">
                            <div class="col">
                                {{ element.inaSchoolEnrollment?.CreatedBy }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                {{ element.inaSchoolEnrollment?.CreatedDate | simpleDate }}
                            </div>
                        </div>

                    </div>
                    <div *ngSwitchCase="'followDate'" class="col">
                        <div *ngIf="element.inaSchoolEnrollment?.FollowUpName && element.inaSchoolEnrollment?.StatusTypeId == 2"
                            class="col">
                            <div class="row">
                                <div class="col">
                                    {{ element.inaSchoolEnrollment?.FollowUpName }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    {{ element.inaSchoolEnrollment?.FollowUpDate | simpleDate }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'isEdit'" class="col">
                        <div class="row">
                            <div *ngIf="viewAccess && showButtonUserRegion && element.isDelete == false"
                                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                                    <button [style.margin-left.px]="editing ? -10 : 20" type="button" mat-icon-button color="primary" [matTooltip]="'View'"
                                        matTooltipPosition="above" (click)="OpenNewTab(element,'view')">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                
                            </div>
                            <div *ngIf="editing && element.isEdit == false && editAccess && showButtonUserRegion"
                                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                                <button [style.margin-left.px]="editing ? -10 : 0" mat-icon-button color="primary" [matTooltip]="'Edit'"
                                    (click)="OpenNewTab(element,'edit')">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </div>
                            <div *ngIf="editing && element.isEdit == false"
                                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">

                                <confirm-popover [style.margin-left.px]="editing ? -10 : 0" [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
                                    [popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
                                    [popoverConfirmColor]="'warn'" [tooltip]="'Delete'" (onConfirm)="deleteRow(element)"
                                    *ngIf="editAccess && showButtonUserRegion">
                                </confirm-popover>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
        aria-label="Select page of periodic elements"></mat-paginator>
</div>